import { handleRegisterLinkClick, resolveBrandNameFromUrl } from '@/utils/trackRegisterClick';

export default function CategoryGrid() {
  const pokerChipIcon = "/poker-chip.png";

  const categories = [
    { 
      name: 'VIP Casinos with Premium Player Benefits',
      link: 'https://www.ipay9aud.co/en-au/?ref=IPAY9C9C43',
    },
    { 
      name: 'New Go-To For Hot Games & Rewards',
      link: 'https://mrboom9.com/RFPPOKINOMICS',
    },
    { 
      name: 'Popular Real Money Online Casinos',
      link: 'https://i9aud.net/RFPOKINOMICS1',
    },
    { 
      name: 'Casinos with High Payout Potential',
      link: 'https://kingbett9.com/RFPOKINOMICS13',
    },
    { 
      name: 'Mobile-Friendly & App-Optimised Casinos',
      link: 'https://bigpay77.co/RFBPOKINOMICS',
    },
    { 
      name: 'Fast Payout Online Casinos',
      link: 'https://me99aus.net/RFPOKINOMICSME',
    },
    { 
      name: 'Live Dealer Casino Games',
      link: 'https://rolex9au.com/RFPOKINOMICSS',
    },
    { 
      name: 'Casinos Offering Free Credit Bonuses',
      link: 'https://gucci9au.org/RFPOKINOMICSG',
    },
    { 
      name: 'VIP & High Roller Casinos',
      link: 'https://winnie777.net/RFPOKINOMICSWI',
    },
    { 
      name: 'Low Minimum Deposit Casinos',
      link: 'https://micky9.net/RFPOKINOMICSMI',
    },
    { 
      name: 'High-Volatility Slot Casinos',
      link: 'https://queen13au.com/RFPOKINOMICSQU',
    },
    { 
      name: 'Progressive Jackpot Casino Games',
      link: 'https://bybid9.net/RFPOKINOMICS',
    },
    { 
      name: 'Popular Online Casino Platforms',
      link: 'https://spinarooaus.com/RFPOKINOMICSP',
    },
    { 
      name: 'Feature-Rich Online Casino Platforms',
      link: 'https://mrbean9au.com/RFPOKINOMICSM',
    },
  ];


  return (
    <section id="popular-casino" className="py-8 md:py-10 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <h1 className="text-xl md:text-4xl font-bold text-gray-900 mb-4 md:mb-8 text-center">
          Popular Australia Online eWallet Casino Categories
        </h1>

        <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
          <div className="grid grid-cols-1 md:grid-cols-2">

            {categories.map((category, index) => (
              <a
                key={index}
                href={category.link}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(event) => handleRegisterLinkClick(event, {
                  section: 'category_grid',
                  brandName: resolveBrandNameFromUrl(category.link),
                  url: category.link,
                })}
                className={`
                  group p-4 md:p-5 flex items-center justify-between
                  hover:bg-gray-50 transition-all cursor-pointer border-b border-gray-200
                  ${index % 2 === 0 ? "md:border-r" : ""}
                  ${index >= categories.length - 2 ? "border-b-0" : ""}
                `}
              >
                {/* Left Section */}
                <div className="flex items-center gap-3 md:gap-4">
                  
                  {/* 🎨 Color Poker Chip Icon */}
                  <img
                    src={pokerChipIcon}
                    alt="poker chip"
                    className="
                      w-5 h-5 md:w-7 md:h-7
                      object-contain
                      transition-transform
                      group-hover:scale-110
                    "
                  />

                  {/* Name */}
                  <span className="text-sm md:text-base text-gray-700 font-medium">
                    {category.name}
                  </span>
                </div>

                {/* Arrow */}
                <i
                  className="
                    ri-arrow-right-s-line 
                    text-gray-400 text-xl
                    transition-transform 
                    group-hover:translate-x-1
                  "
                />
              </a>
            ))}

          </div>
        </div>

      </div>
    </section>
  );
}
